<template>
  <!-- 取消发货（小紫中台订单）：原因必选，选"其他"时说明必填 -->
  <el-dialog title="取消发货" :visible="visible" width="520px" :close-on-click-modal="false" @close="close" @closed="reset">
    <p class="tip-code">发货单号：{{ delivery.code }}</p>
    <el-form ref="cancelForm" :model="form" :rules="rules" label-width="80px" size="small">
      <el-form-item label="取消原因" prop="cancelReasonType">
        <el-select v-model="form.cancelReasonType" placeholder="请选择取消原因" style="width: 100%;">
          <el-option v-for="item in reasonOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="说明" prop="cancelReason">
        <el-input
          v-model="form.cancelReason"
          type="textarea"
          :rows="3"
          maxlength="500"
          show-word-limit
          :placeholder="form.cancelReasonType === 3 ? '请输入说明（必填）' : '请输入说明'"
        ></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button size="small" @click="close">取消</el-button>
      <el-button size="small" type="primary" :loading="loading" @click="submit">确定取消发货</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { cancelDelivery } from '@/api/invoiceMgr';

export default {
  name: 'CancelDeliveryDialog',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    // 发货单：{ id, code }
    delivery: {
      type: Object,
      default: () => ({}),
    },
  },
  data () {
    const validateCancelReason = (rule, value, callback) => {
      if (this.form.cancelReasonType === 3 && !(value || '').trim()) {
        callback(new Error('取消原因为其他时，请填写说明'));
      } else {
        callback();
      }
    };
    return {
      loading: false,
      reasonOptions: [
        { label: '货未发出', value: 1 },
        { label: '信息录错重发', value: 2 },
        { label: '其他', value: 3 },
      ],
      form: {
        cancelReasonType: '',
        cancelReason: '',
      },
      rules: {
        cancelReasonType: [{ required: true, message: '请选择取消原因', trigger: 'change' }],
        cancelReason: [{ validator: validateCancelReason, trigger: 'blur' }],
      },
    };
  },
  methods: {
    close () {
      this.$emit('update:visible', false);
    },
    reset () {
      this.$refs.cancelForm && this.$refs.cancelForm.resetFields();
      this.loading = false;
    },
    submit () {
      this.$refs.cancelForm.validate(async (valid) => {
        if (!valid) {
          return;
        }
        this.loading = true;
        try {
          // 后端会先同步询问中台能否取消，被拒时由接口返回原因并提示
          await cancelDelivery({
            id: this.delivery.id,
            cancelReasonType: this.form.cancelReasonType,
            cancelReason: (this.form.cancelReason || '').trim(),
          });
          this.$message.success('取消成功!');
          this.close();
          this.$emit('success');
        } finally {
          this.loading = false;
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.tip-code {
  margin-bottom: 12px;
  color: #606266;
}
</style>
